var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hook-container"},[_c('div',{ref:"hook"})])
}
var staticRenderFns = []

export { render, staticRenderFns }